import { MapGeoJSONFeature } from "maplibre-gl";
import Resizer from "react-image-file-resizer";
import { Feature } from "../api-clients/iwannacamp-api";

const CF_ACCOUNT_ID = import.meta.env.VITE_CF_IMAGES_ACCOUNT_HASH || "";
const CF_IMAGE_URL_BASE = `https://imagedelivery.net/${CF_ACCOUNT_ID}/`;

export const getImageUrl = (
  imageId: string,
  size?: "card" | "large" | "public"
) => {
  return CF_IMAGE_URL_BASE + imageId + "/" + (size || "card");
};

export const getCampgroundHeroImageId = (
  campground: MapGeoJSONFeature | Feature
): string | undefined => {
  const properties = campground.properties;
  return properties?.hero_image_id;
};

export const getCampgroundHeroImageUrl = (
  campground: MapGeoJSONFeature | Feature,
  size?: "card" | "large"
): string | undefined => {
  const heroImageId = getCampgroundHeroImageId(campground);
  return heroImageId ? getImageUrl(heroImageId, size) : undefined;
};

/**
 * Resize an image file to reduce file size before upload.
 * Resizes to max 1920x1080, outputs JPEG at 85% quality.
 * Target output: ~500KB-2MB (down from potential 10MB+)
 * Note: EXIF metadata will be lost in the process.
 */
export const resizeImage = (file: File): Promise<File> => {
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      2160, // maxWidth
      1440, // maxHeight
      "JPEG", // format
      95, // quality (0-100)
      0, // rotation
      (resizedFile) => resolve(resizedFile as File),
      "file" // output type
    );
  });
};
